import { defineComponent as _defineComponent } from 'vue'
import UserAvatar from "@/components/profile/UserAvatar.vue"
import { UnreadConversationsQuery, UnreadConversationsQueryQuery } from "@/gql"
import { useQuery } from "@vue/apollo-composable"
import { useTimeAgo } from "@/hooks/useTimeAgo"


export default /*#__PURE__*/_defineComponent({
  __name: 'UnreadConversations',
  setup(__props) {

const { result } = useQuery<UnreadConversationsQueryQuery>(UnreadConversationsQuery)

const timeAgo = (date: Date) => {
  return useTimeAgo(date)
}

return { __sfc: true,result, timeAgo, UserAvatar }
}

})